import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { StoreProvider } from './store';
import { Header, Footer } from './components/Layout';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Catalogue from './pages/Catalogue';
import ServiceDetail from './pages/ServiceDetail';
import Configure from './pages/Configure';
import Problem from './pages/Problem';
import Basket from './pages/Basket';
import Checkout from './pages/Checkout';
import Workspace from './pages/Workspace';
import Knowledge from './pages/Knowledge';
import Discovery from './pages/Discovery';
import './App.css';

function Shell(){
  const {pathname}=useLocation();
  useEffect(()=>{window.scrollTo(0,0);},[pathname]);
  return <><Header/><main id="main-content"><Routes>
    <Route path="/" element={<Home/>}/><Route path="/services" element={<Catalogue/>}/>
    <Route path="/discover/:practice" element={<Discovery/>}/>
    <Route path="/services/:id" element={<ServiceDetail/>}/><Route path="/configure/:id" element={<Configure/>}/>
    <Route path="/problem" element={<Problem/>}/><Route path="/basket" element={<Basket/>}/>
    <Route path="/checkout" element={<Checkout/>}/><Route path="/workspace" element={<Workspace/>}/>
    <Route path="/workspace/:id" element={<Workspace/>}/><Route path="/knowledge" element={<Knowledge/>}/>
    <Route path="*" element={<div className="page empty" data-testid="not-found"><h1>That page isn’t here.</h1><a href="/" data-testid="return-home">Return to services →</a></div>}/>
  </Routes></main><Footer/><Toaster position="bottom-right"/></>;
}
export default function App(){return <BrowserRouter><StoreProvider><Shell/></StoreProvider></BrowserRouter>;}